module.exports = __webpack_public_path__ + "static/media/home-service-slider-1.4423391e.jpg";